import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { useRole } from "../context/RoleContext";
import { cacheConfig, QueryKeys } from "./constants";
import {
  getCartByCustomerId,
  updateCartByCustomerIdService,
} from "../service/cartService";
import { normalizeRole } from "../utils/roleUtils";

type CartResponse = Awaited<ReturnType<typeof getCartByCustomerId>>;

export const useCart = (enabled?: boolean) => {
  const location = useLocation();
  const { role } = useRole();

  const isSellerRoute =
    normalizeRole(role) === "maltora-seller" ||
    location.pathname === "/maltora-seller" ||
    location.pathname.startsWith("/maltora-seller/");

  return useQuery<CartResponse>({
    queryKey: [QueryKeys.Cart],
    queryFn: isSellerRoute ? () => Promise.resolve(null) : getCartByCustomerId,
    enabled: enabled ?? true,
    ...cacheConfig.oneHour,
  });
};

export const useUpdateCart = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCartByCustomerIdService,
    onSuccess: (updatedCartData) => {
      queryClient.setQueryData<CartResponse>([QueryKeys.Cart], updatedCartData);
    },
  });
};
